import { ArrowDownOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, message, Modal, Row, Space } from "antd";
import { FormProps } from "antd/lib";
import React, { useEffect, useState } from "react";
import { PATCH } from "../../../services";
import { UPLIFT_UPDATE_CUTTING } from "../../../services/path";

interface MyModalProps {
  visible: boolean;
  onClose: () => void;
  sku: string;
  alter_sku: string;
  cutting_id: string;
  open: boolean;
  onCancel: () => void;
  width?: string | number;
  centered?: boolean;
  bodyStyle?: React.CSSProperties;
  children?: React.ReactNode;
  alter_name?: string; // Optional prop for alter name
  user?: any; // Optional prop for user context
}

const AddMapCodeGModal: React.FC<MyModalProps> = ({
  visible,
  onClose,
  sku,
  alter_sku,
  cutting_id,
  open,
  onCancel,
  width = "50%",
  centered = true,
  bodyStyle = {},
  alter_name,
  user,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const handleDisableSaveButton = () => {
    const { sku, alter_sku, cutting_id, alter_name } = form.getFieldsValue();
    setCanSave(!!(sku && alter_sku && cutting_id && alter_name)); // Use double negation to ensure boolean
  };

  const onValuesChange = () => {
    handleDisableSaveButton();
  };

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        sku,
        alter_sku,
        alter_name,
        cutting_id,
      });

      handleDisableSaveButton(); // Check if the save button should be enabled
    }
  }, [visible, sku, alter_sku, cutting_id, alter_name, form]);

  useEffect(() => {
    if (!visible) {
      form.resetFields(); // Reset form fields when modal closes
    }
  }, [visible, form]);

  const confirmClose = () => {
    Modal.confirm({
      title: "ต้องการปิดหน้าต่างนี้ไหม",
      content: "หากไม่กดบันทึก ข้อมูลจะไม่ถูกแก้ไข",
      onOk() {
        onClose();
      },
      onCancel() {
        console.log("Cancel close");
      },
    });
  };

  const handleOnSaveButtonClick: FormProps["onFinish"] = async (values) => {
    setIsLoading(true);
    try {
      const { sku, alter_sku, alter_name, cutting_id } = form.getFieldsValue();
      const payload = {
        sku: sku,
        alter_sku: alter_sku,
        alter_name: alter_name,
        cutting_id: cutting_id,
      };

      const response = await PATCH(UPLIFT_UPDATE_CUTTING, payload);
      if (response) {
        message.success("บันทึกข้อมูล Code G สำเร็จ");
      } else {
        message.error("ไม่สามารถบันทึกข้อมูล Code G ได้");
      }
    } catch (error) {
      console.error("Error saving data:", error);
      message.error("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setIsLoading(false);
      onClose(); // Close the modal after saving
    }
  };

  return (
    <Modal
      title={
        <h2
          style={{
            fontWeight: "normal",
          }}
        >
          แก้ไขข้อมูล
        </h2>
      }
      open={visible}
      onCancel={confirmClose}
      okText="Save"
      cancelText="Cancel"
      confirmLoading={isLoading}
      okButtonProps={{ disabled: !canSave }}
      footer={[
        <div style={{ textAlign: "center" }} key="footer">
          <Space>
            <Button
              key="submit"
              type="primary"
              loading={isLoading}
              style={{ borderRadius: "0.15rem" }}
              disabled={!canSave}
              onClick={handleOnSaveButtonClick}
            >
              บันทึก
            </Button>
            <Button
              key="back"
              onClick={confirmClose}
              className="ant-btn-color-geekblue"
              style={{ borderRadius: "0.15rem" }}
            >
              ยกเลิก
            </Button>
          </Space>
        </div>,
      ]}
    >
      <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="sku"
              label={
                <div>
                  <span style={{ color: "red" }}>*</span> รหัสเนื้อฟิล์ม (SKU)
                </div>
              }
            >
              <Input placeholder="ใส่ข้อมูลรหัสสินค้า" disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="alter_sku"
              label={
                <div>
                  <span style={{ color: "red" }}>*</span> รหัสรุ่น (alter_SKU)
                </div>
              }
            >
              <Input placeholder="ใส่ข้อมูลชื่อสินค้า" disabled={true} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Form.Item
              name="alter_name"
              label={
                <div>
                  <span style={{ color: "red" }}>*</span> ชื่อรุ่น (alter_name)
                </div>
              }
            >
              <Input placeholder="ใส่ข้อมูล ID เครื่องปริ้น" disabled={isLoading} />
            </Form.Item>
          </Col>
        </Row>
        <Row style={{ height: "10vh", textAlign: "center" }} justify="center" align="middle">
          <ArrowDownOutlined
            style={{
              padding: "30px 0",
              fontSize: "50px",
              color: "#1890ff", // Ant Design primary color
            }}
          />
        </Row>
        <Row gutter={[24, 16]}>
          <Col span={24}>
            <Form.Item
              name="cutting_id"
              label={
                <div>
                  <span style={{ color: "red" }}>*</span> ID เครื่องปริ้น
                </div>
              }
            >
              <Input placeholder="ใส่ข้อมูล ID เครื่องปริ้น" disabled={isLoading} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddMapCodeGModal;
